import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, FieldArray, getFormValues } from 'redux-form';

import ContentCard from '../common/template/contentCard';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import Select from '../common/form/select';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import {
    setModoTela,
    initForm
} from './fornecedorActions';

let FornecedorForm = props => {

    const formulario = props.formularioValues || {};
    const readOnly = props.excluir ? 'readOnly' : '';

    const pessoaFisica = formulario.tipo_pessoa === 'fisica';
    const pessoaJuridica = formulario.tipo_pessoa === 'juridica';

    const alterarTipoPessoa = tipoPessoa => {
        props.initForm({
            ...formulario,
            tipo_pessoa: tipoPessoa,
            nome_fantasia: null,
            razao_social: null,
            cnpj: null,
            cpf: null
        });
    };

    return (
        <ContentCard>
            <Form event={props.handleSubmit}>
                <ContentCardBody>

                    {!formulario.id &&
                        <Row>
                            <Field
                                name='tipo_pessoa'
                                options={[
                                    { id: 'fisica', valor: 'Pessoa Física' },
                                    { id: 'juridica', valor: 'Pessoa Jurídica' }
                                ]}
                                component={Select}
                                label='Tipo'
                                placeholder='Informe'
                                cols='12 2 2 2'
                                readOnly={readOnly}
                                value={formulario.tipo_pessoa}
                                onChange={alterarTipoPessoa}
                            />
                        </Row>}

                    <Row>
                        {pessoaJuridica &&
                            <Field
                                name='razao_social'
                                component={LabelAndInput}
                                label='Razão Social *'
                                placeholder='Informe'
                                cols='12 5 5 5'
                                readOnly={readOnly}
                            />}

                        {pessoaJuridica &&
                            <Field
                                name='nome_fantasia'
                                component={LabelAndInput}
                                label='Nome Fantasia *'
                                placeholder='Informe'
                                cols='12 5 5 5'
                                readOnly={readOnly}
                            />}

                        {pessoaFisica &&
                            <Field
                                name='razao_social'
                                component={LabelAndInput}
                                label='Nome *'
                                placeholder='Informe'
                                cols='12 5 5 5'
                                readOnly={readOnly}
                            />}
                    </Row>

                    <Row>
                        {pessoaJuridica &&
                            <Field
                                name='cnpj'
                                component={LabelAndInputMask}
                                label='CNPJ *'
                                placeholder='Informe'
                                cols='12 1 1 1'
                                minWidth={220}
                                readOnly={readOnly}
                                mask='99.999.999/9999-99'
                            />}

                        {pessoaFisica &&
                            <Field
                                name='cpf'
                                component={LabelAndInputMask}
                                label='CPF *'
                                placeholder='Informe'
                                cols='12 1 1 1'
                                minWidth={180}
                                readOnly={readOnly}
                                mask='999.999.999-99'
                            />}

                        <Field
                            name='ie'
                            component={LabelAndInput}
                            label='Inscrição Estadual'
                            placeholder='Informe'
                            cols='12 1 1 1'
                            minWidth={180}
                            readOnly={readOnly}
                        />
                    </Row>

                    <Row>
                        <Field
                            name='endereco'
                            component={LabelAndInput}
                            label='Endereço *'
                            placeholder='Informe'
                            cols='12 4 3 3'
                            readOnly={readOnly}
                        />

                        <Field
                            name='numero'
                            component={LabelAndInput}
                            label='Número'
                            placeholder='Informe'
                            cols='12 3 2 2'
                            readOnly={readOnly}
                        />

                        <Field
                            name='complemento'
                            component={LabelAndInput}
                            label='Complemento'
                            placeholder='Informe'
                            cols='12 3 3 3'
                            readOnly={readOnly}
                        />
                    </Row>

                    <Row>
                        <Field
                            name='bairro'
                            component={LabelAndInput}
                            label='Bairro'
                            placeholder='Informe'
                            cols='12 4 3 3'
                            readOnly={readOnly}
                        />

                        <Field
                            name='cep'
                            component={LabelAndInputMask}
                            label='CEP *'
                            placeholder='Informe'
                            cols='12 4 2 2'
                            readOnly={readOnly}
                            mask='99999-999'
                        />

                        <Field
                            name='id_cidade'
                            options={props.listaCidade || []}
                            component={Select}
                            label='Cidade *'
                            placeholder='Informe'
                            cols='12 12 7 7'
                            readOnly={readOnly}
                        />
                    </Row>

                    <FieldArray
                        name='contatos'
                        component={renderContatos}
                        readOnly={readOnly}
                    />

                </ContentCardBody>

                <ContentCardFooter>
                    <Row alignCenter>
                        <Grid cols='6 6 4 3'>
                            <Button
                                text='Voltar'
                                type='light'
                                icon='fa fa-chevron-left'
                                event={() => props.setModoTela('lista')}
                            />
                        </Grid>

                        <Grid cols='6 6 4 3'>
                            {props.excluir &&
                                <Button
                                    text='Excluir'
                                    submit
                                    type='danger'
                                    icon='fa fa-trash'
                                />}

                            {!props.excluir &&
                                <Button
                                    text='Salvar'
                                    submit
                                    type='success'
                                    icon='fa fa-check'
                                />}
                        </Grid>
                    </Row>
                </ContentCardFooter>
            </Form>
        </ContentCard>
    );
};

const renderContatos = ({ fields, readOnly }) => (
    <div style={{ width: '100%' }}>

        {fields.map((contato, index) => (
            <div
                key={index}
                style={{
                    display: 'flex',
                    alignItems: 'flex-end',
                    gap: 10,
                    marginBottom: 10
                }}
            >
                <div style={{ flex: 1 }}>
                    <Row>
                        <Field
                            name={`${contato}.nome`}
                            component={LabelAndInput}
                            label={index === 0 ? 'Contato *' : 'Contato'}
                            placeholder='Informe'
                            cols='12 4 4 4'
                            maxWidth={350}
                            readOnly={readOnly}
                        />

                        <Field
                            name={`${contato}.celular`}
                            component={LabelAndInputMask}
                            label={index === 0 ? 'Celular *' : 'Celular'}
                            placeholder='Informe'
                            cols='12 3 3 3'
                            maxWidth={180}
                            readOnly={readOnly}
                            mask='(99) 9 9999-9999'
                        />

                        <Field
                            name={`${contato}.email`}
                            component={LabelAndInput}
                            label={index === 0 ? 'E-mail' : 'E-mail'}
                            placeholder='Informe'
                            cols='12 4 4 4'
                            maxWidth={240}
                            readOnly={readOnly}
                        />

                        {!readOnly &&
                            <Grid cols='12 1 1 1'>
                                <button
                                    type='button'
                                    title='Remover contato'
                                    onClick={() => fields.remove(index)}
                                    style={{
                                        height: 38,
                                        width: 38,
                                        border: 'none',
                                        borderRadius: 10,
                                        background: '#dc3545',
                                        color: '#fff',
                                        cursor: 'pointer',
                                        marginTop: 29,
                                        boxShadow: '0 2px 6px rgba(220, 53, 69, .35)'
                                    }}
                                >
                                    <i className='fa fa-trash'></i>
                                </button>
                            </Grid>}
                    </Row>
                </div>
            </div>
        ))}

        {!readOnly &&
            <Row>
                <Grid cols='12 3 3 2'>
                    <button
                        type='button'
                        onClick={() => fields.push({
                            id: null,
                            nome: '',
                            celular: '',
                            email: ''
                        })}
                        style={{
                            height: 38,
                            padding: '0 16px',
                            border: 'none',
                            borderRadius: 10,
                            background: '#007bff',
                            color: '#fff',
                            fontWeight: 600,
                            cursor: 'pointer',
                            boxShadow: '0 2px 6px rgba(0, 123, 255, .35)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 8
                        }}
                    >
                        <i className='fa fa-plus'></i>
                        Adicionar contato
                    </button>
                </Grid>
            </Row>}

    </div>
);

FornecedorForm = reduxForm({
    form: 'fornecedorForm',
    destroyOnUnmount: false
})(FornecedorForm);

const mapStateToProps = state => ({
    sessao: state.auth.usuario,
    formularioValues: getFormValues('fornecedorForm')(state),
    registro: state.fornecedor.registro,
    listaCidade: state.cidade.listaSelect
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setModoTela,
    initForm
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FornecedorForm);